import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/vercel/path0/components/ui/sonner.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/@solana+wallet-adapter-react-ui@0.9.35_@solana+web3.js@1.98.0_bufferutil@4.0.9_utf-8-validate_jlp7g33uyh3ca3f7dkhvwotjja/node_modules/@solana/wallet-adapter-react-ui/styles.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["SolanaProvider"] */ "/vercel/path0/providers/SolanaProvider.tsx");
